import { render, staticRenderFns } from "./admIcon.vue?vue&type=template&id=b300750a"
import script from "./admIcon.vue?vue&type=script&lang=js"
export * from "./admIcon.vue?vue&type=script&lang=js"
import style0 from "./admIcon.vue?vue&type=style&index=0&id=b300750a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports